<template>
    <div class="accordion-content" 
         :class="open">
        <div class="accordion-header">
            <div class="header-button">
                <div class="button" :class="{'clicked': open == 'open-body'}">
                    <!-- <img src="/img/icons/arrow_brown.png" class="img-button" :style="{ 'transform' : `rotate(${rotateImg})`}"> -->
                    <Arrow 
                        class="img-button" 
                        :fill="open !== 'open-body' ? colors.secondary : 'none'"
                        :stroke="colors.secondary"
                        :style="{ 'transform' : `rotate(${rotateImg})`}
                    "></Arrow>
                </div>
            </div>
            <div class="header-title">
                <span class="title-text" :style="{color : colors.theme == 'dark' ? '#fff' : '#000'}" :class="{ 'title-bold' : text.competence == true }" v-for="(text, index) in title" :key="index">
                    {{ text.title }} 
                    <span class="x"
                    :style="{
                        color: colors.theme == 'dark' ? '#fff' : '#000'
                    }">{{ index == 0 ? 'x' : ''}}
                    </span>  
                </span>
            </div>
        </div>
        <div class="accordion-body" :class="open">
            <div class="body-text">
                <span class="desc-body">{{ text }}</span>
            </div>
        </div>
    </div>
</template>
<script>
import Arrow from '../../customIcons/report/Arrow.vue'
export default {
    components: {
        Arrow
    },
    data(){
        return{
            colors : {},
            style: {}
        }
    },
    props : {
        title : {
            type : Array,
            required : true
        },
        text : {
            type : String,
            required : true
        },
        open : {
            type : String,
            required : true
        },
        index : {
            type : Number,
            required : true
        }
    },
    computed : {
        // colorBackground(){
        //     if(this.open != 'open-body') return this.index % 2 == 0 ? this.colors.backgrounds.solidLight + "70" : this.colors.backgrounds.solidLight
        // },
        rotateImg(){
            return this.open == 'open-body' ? '90deg' : '0deg'
        }
    },

    created(){
        this.colors = JSON.parse(localStorage.getItem("colors"));
        // console.log('__OPEN: ', this.open)
        // console.log('Title_: ', this.title)
        let self = this
        if(self.title[1].competence) [self.title[0], self.title[1]] = [self.title[1], self.title[0]];
        // if(this.open == 'open-body') this.style = {'background-color': 'transparent'}
        // if(this.colors.theme == 'dark' && !this.open == 'open-body') this.style = {'background-color': '#0a1721'}
        // if(this.colors.theme == 'light' && !this.open == 'open-body') this.style = {'background-color': '#f0f0f0'}
    }
}
</script>
<style lang="scss">
// Teste
    .accordion-content{
        
        display: flex;
        flex-direction: column;
        height: 100%;
        width: 100%;

        .accordion-header{

            display: flex;
            align-items: center;
            height: 70px;
            padding: 0 10%;
            transition: background .5s;

            .header-button{

                margin: 2% 0;
                width: 15%;
                display: flex;
                justify-content: center;

                .button{

                    border: none;
                    width: 25px;
                    height: 25px;
                    // box-shadow: 0px 4px 0px 0px rgba(0,0,0,0.2);
                    transition: border .5s;

                    .img-button{

                        width: 17px;
                        transition: 0.5s;
                        
                    }
                }
                .button.clicked{
                    box-shadow: none;
                    border: none
                }
            }

            .header-title{
                font-size: 15px;
                // letter-spacing: 3px;

                .title-text{
                    font-weight: 500;
                    // text-transform: uppercase;

                    .x{
                        // color: black;
                        font-weight: 500;
                        font-size: 11px;
                    }
                }

                .title-bold{
                    font-weight: 900;
                    font-size: 21px;
                }
            }
        }

        .accordion-body{
            
            margin: 0% 20% 0 20%;

            .body-text{
                letter-spacing: 1.5px;
                // word-spacing: 4px;
                font-size: 15px;
                line-height: 19px;
                display: flex;
                justify-content: center;
                align-items: center;
                padding: 10px 0;
            }
        }
        .closed-body{
            display: none;
        }
        .open-body{
            display: flex;
            flex: 1;
            flex-direction: column;
            // overflow: hidden;
            overflow-y: auto;
            transition-duration: 500ms;
            z-index: 1;
            

            .accordion-header{
                height: auto;
                padding-bottom: 5px;
                padding-top: 5px;
            }
        }
    }

    @media only screen and (max-height: 600px){
        .accordion-content{

            .accordion-header{

                height: 45px;
            }
        }
    }

    // @media only screen and (min-height: 601px){
    //     .accordion-content{

    //         .accordion-header{

    //             height: 60px;
    //         }
    //     }
    // }

    @media only screen and (min-height: 800px){
        .accordion-content{

            .accordion-header{

                height: 100px;
            }
        }
    }

    @media only screen and (min-width: 900px){
        .accordion-content{

            .accordion-header{

                height: 80px;
            }
        }
    }
    @media only screen and (min-width: 380px) and (min-height: 700){
        .open-body{
            .accordion-content{

                .accordion-header{

                    height: 95px;
                }
            }

        }
    }
    @media only screen and (min-width: 501px){
        .accordion-body{
            overflow-y: hidden;
        }
    }


    
</style>

   